import { callApi } from 'utils/api'
import crud from './_crud'
import Swal from 'sweetalert2'
import i18next from 'i18next'
const t = (key) => i18next.t(key)

export const LOGO_TOKEN_VALIDATED_SUCCESS = 'LOGO_TOKEN_VALIDATED_SUCCESS'
export const LOGO_TOKEN_VALIDATED_ERROR = 'LOGO_TOKEN_VALIDATED_ERROR'

export const logoTokenValidatedSuccess = (logoUrl, loginTitle, loginSubtitle) => ({
	type: LOGO_TOKEN_VALIDATED_SUCCESS,
	payload: { logoUrl, loginTitle, loginSubtitle },
})

export const logoTokenValidatedError = (error) => ({
	type: LOGO_TOKEN_VALIDATED_ERROR,
	payload: { error },
})

export const validateLogoToken = (logoToken) => {
	return async (dispatch) => {
		try {
			// Llamar al API para validar el logo_token
			const response = await callApi(`/app/validateLogoToken?e=${logoToken}`, {
				method: 'POST',
				body: JSON.stringify({ logoToken }),
			})
			const data = await response
			if (response) {
				if (data.body.logoUrl) {
					// Puedes despachar una acción de éxito y devolver el URL del logo
					dispatch(
						logoTokenValidatedSuccess(
							data.body.logoUrl,
							data.body.loginTitle,
							data.body.loginSubtitle
						)
					)
					return data.body.logoUrl
				} else {
					console.error('Error: Logo URL not provided in the response')
					// Puedes despachar una acción de error si es necesario
					dispatch(
						logoTokenValidatedError('Logo URL not provided in the response')
					)
				}
			} else {
				console.error('Error validating logo token:', data.error)
				// Puedes despachar una acción de error si es necesario
				dispatch(logoTokenValidatedError(data.error))
			}
		} catch (error) {
			console.error('Error validating logo token:', error.message)
			// Puedes despachar una acción de error si es necesario
			dispatch(logoTokenValidatedError(error.message))
		}
	}
}

const upsertSysCompanyBusinessDays = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/sys_company/upsert_sys_company_business_days`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				item,
			}),
			// successMessage: `Se registraton los días hábiles correctamente.`,
		})
		Swal.fire({
			title: t('¡Acción Realizada!'),
			text: t('Se registraton los días hábiles correctamente.'),
			icon: 'success',
			confirmButtonText: t('OK'),
			showCloseButton: true,
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.reload()
			}
		})
		return res.body
	}
}

const getSysCompanyBusinessDays = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/sys_company/utils/get_sys_company_business_days`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			}
		)

		return res.body
	}
}

const getAutoSavePassword = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/sys_company/get_auto_save_password`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

const saveAutoSavePassword = (autoSavePassword) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/sys_company/save_auto_save_password`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				auto_save_password: autoSavePassword,
			}),
		})

		return res.body
	}
}

const getForcePassengerPasswordChange = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/sys_company/get_force_passenger_password_change`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

const saveForcePassengerPasswordChange = (forcePassengerPasswordChange) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/sys_company/save_force_passenger_password_change`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				force_passenger_password_change: forcePassengerPasswordChange,
			}),
		})

		return res.body
	}
}

const actions = {
	...crud('sys_module', 'la compañía del sistema', 'las compañías del sistema'),
	validateLogoToken,
}

export default {
	...actions,
	upsertSysCompanyBusinessDays,
	getSysCompanyBusinessDays,
	getAutoSavePassword,
	saveAutoSavePassword,
	getForcePassengerPasswordChange,
	saveForcePassengerPasswordChange,
}
